/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Candidate_Profile_Job_Type_PlaceholderInputs */

const en_candidate_profile_job_type_placeholder = /** @type {(inputs: Candidate_Profile_Job_Type_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e.g., Internship, Full-time`)
};

const de_candidate_profile_job_type_placeholder = /** @type {(inputs: Candidate_Profile_Job_Type_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`z.B. Praktikum, Vollzeit`)
};

/**
* | output |
* | --- |
* | "e.g., Internship, Full-time" |
*
* @param {Candidate_Profile_Job_Type_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const candidate_profile_job_type_placeholder = /** @type {((inputs?: Candidate_Profile_Job_Type_PlaceholderInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Candidate_Profile_Job_Type_PlaceholderInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_candidate_profile_job_type_placeholder(inputs)
	return en_candidate_profile_job_type_placeholder(inputs)
});